<template>
  <v-dialog v-model="modal" eager>
    <viewPersonneMorale
      ref="view"
      :enums="enums"
      :form="form"
      :control="control"
      :dsType="dsType"
      :filiales="filiales"
      :divisions="divisions"
      :contacts="contacts"
    >
      <v-card-actions>
        <v-btn text @click="annuler">
          Annuler
        </v-btn>

        <v-btn text @click="creerPM">
          Créer et associer
        </v-btn>
      </v-card-actions>
    </viewPersonneMorale>
  </v-dialog>
</template>
<script>
import Datasource from '@/utils/datasource';
import EditeurEntite from '@/plugins/mixins/EditeurEntite';
import ViewPersonneMorale from '@/view/personnemorale/ViewPersonneMorale';
import { nettoyageTelephone } from '@/view/personnemorale/personnemoraleUtils';
import toasted from '@/utils/toasted';

export default {
  components: {
    viewPersonneMorale: ViewPersonneMorale,
  },
  props: {
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    enDemandeCreation: {
      type: Boolean,
      default: false,
    },
    adressesSaisies: {
      type: Array,
    },
  },
  mixins: [EditeurEntite],

  data() {
    // Le type de PM
    var dsType;

    return {
      modal: false,
      type: null,
      // Datasources
      dsType,

      // Configuration de l'IHM
      control: {
        readonly: false,
        enDemandeModification: false,
        noPrint: true,
      },

      // Les enums
      enums: {
        contextes: [],
        cotiseA: [],
        types: [],
      },
      commentaire: null,
      // Le formulaire
      form: {
        id: null,
        nomUsuel: null,
        raisonSociale: null,
        sirenOuSiret: null,
        type: {
          id: null,
          libelle: null,
        },
        mail: null,
        fax: null,
        domicilieeMDL: false,
        organisationPro: false,
        siteInternet: null,

        // Collections
        adresses: [],
        telephones: [],
        maisonsMeres: [],
        contextes: [],
        cotiseA: [],

        // RGPD
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
        demandeurCreation: null,
      },

      // Obets affichés mais non modifiés
      filiales: null,
      divisions: [],
      contacts: [],
    };
  },
  beforeMount() {
    this.buildDatasource();
    this.creationPromiseEnums();
  },
  methods: {
    show() {
      this.modal = true;
      this.initForm();
      if (this.$refs.view) {
        this.$refs.view.panel.push(0);
        this.$refs.view.panel.push(1);
      }
    },
    buildDatasource() {
      this.dsType = new Datasource('abstractenum/typepersonnemorale', {
        rowsPerPage: 50,
        sortBy: 'libelle',
      });
    },

    // Gestion de l'initialisation du formulaire
    initForm() {
      this.form.adresses = this.adressesSaisies;
    },
    // Appelée après chargement des listes d'enums depuis le Back
    initEnums(body) {
      const enums = this.enums;
      enums.contextes = body.contextes;
      enums.cotiseA = body.cotiseA;
      enums.types = body.types;
    },
    // Appelée par le mixin Entite
    creationPromiseEnums() {
      return this.$api('enums/personnemorale')
        .get()
        .then(response => {
          const body = response.body;
          this.initEnums(body);
        });
    },

    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },
    annuler() {
      this.modal = false;
    },
    creerPM() {
      const copy = nettoyageTelephone(this.form);
      return this.$api('personne-morale')
        .put(copy)
        .then(response => {
          toasted.info('Personne morale créée et associée');
          this.modal = false;
          const valeur = {
            id: response.body.id,
            raisonSociale: response.body.raisonSociale,
            nomUsuel: response.body.nomUsuel,
            type: response.body.type,
          };
          this.$emit('input', valeur);
        })
        .catch(errors => {
          this.errorsHandler(errors);
        });
    },
  },
};
</script>
